module.exports = __webpack_public_path__ + "img/symbol_3.d5ff124d.png";